import { render } from "./VideoAds.vue?vue&type=template&id=05d5f2fa"
import script from "./VideoAds.vue?vue&type=script&lang=js"
export * from "./VideoAds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__